import React from 'react';
import { motion } from 'framer-motion';
import { WATERMARK_CONFIG } from '../../../../common/utility/constant';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="demo-footer">
      <div className="container">
        <motion.p
          className="footer-question"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <strong>Questions?</strong> We're here to help.
        </motion.p>
        
        <motion.p
          className="footer-contact"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          📧 Email: charts@vtrender.com
        </motion.p>
        
        <motion.p
          className="footer-copyright"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {WATERMARK_CONFIG.TEXT}. All rights reserved. NSE registered member.
        </motion.p>
      </div>
    </footer>
  );
};

export default Footer;

